// extracted by mini-css-extract-plugin
module.exports = {"campaignReportTableContainer":"CampaignReportTable_campaignReportTableContainer__Fp8K-","campaignReportTable":"CampaignReportTable_campaignReportTable__2n1X1"};